

import Activity from "../../activity/model/Activity";
import DragContainerModel from './DragContainerModel'
import DragItem from "./DragItem";
import DropItemContainer from './DropItemContainer'


class DragWordToImgActivity extends Activity {


    constructor() {
        super()
        this.activityType = this.DRAG_WORD_TO_IMG;
        this.dragContainerModel = new DragContainerModel()
        this.dropItemContainer = new DropItemContainer()
        this.currentDragItem=new DragItem()
        this.imgUrl = "http://s3.amazonaws.com/cdn.testengine.com/CONTENT/DRAG_DROP/"

    }


    getAnsweredTrue = () => { 

        let {dropItemList}=this.dropItemContainer

        
        for(let i=0;i<dropItemList.length;i++){
            let result=false
            console.log(dropItemList[i].solvedDragItem)
            for(let j=0;j<dropItemList[i].dragList.length;j++){
                if(dropItemList[i].solvedDragItem.dragIndex==dropItemList[i].dragList[j].dragIndex){
                    result=true
                }
               
            }
            if(!result){
                this.answeredTrue=false
            }
            
        }
    }
    resetActivity=()=>{
        this.answeredTrue=true;

        let {dropItemList}=this.dropItemContainer

        for(let i=0;i<dropItemList.length;i++){
            dropItemList[i].solvedDragItem=new DragItem();
            dropItemList[i].dropTxt = "........"
        }

    }

    initFromJson = (obj) => {

        this.initPublicItemsFromJson(obj)
        this.dragContainerModel.initFromJson(obj.dragContainerModel)
        this.dropItemContainer.initFromJson(obj.dropItemContainer)

    }


    getAsJson = () => {
        let jsCode = this.getPublicItemsAsJson();
        jsCode.dragContainerModel = this.dragContainerModel.getAsJson()
        return jsCode
    }


    getReportAsJson=()=>{
        let jsCode = this.getPublicItemsAsJson();
        jsCode.dragContainerModel = this.dragContainerModel.getReportAsJson()
        jsCode.dropItemContainer = this.dropItemContainer.getReportAsJson()
        jsCode.answeredTrue=this.answeredTrue

        return jsCode
    }


    initReportFromJson=(obj)=>{
    
        this.initPublicItemsFromJson(obj)
        this.dragContainerModel.initReportFromJson(obj.dragContainerModel)
        this.dropItemContainer.initReportFromJson(obj.dropItemContainer)
        this.answeredTrue=obj.answeredTrue

    }

    initSharedItems = (activityArr) => {
        this.initPublicSharedItem(activityArr);
    }

}

export default DragWordToImgActivity